import React, { useContext } from "react";
import { observer } from "mobx-react";

import { MyBetsBetContext } from "@state/context/my-bets/MyBetsBetContext";
import classNames from "classnames";
import { MyBetsStoreContext } from "@state/context/my-bets/MyBetsStoreContext";

export default observer(function AutosellButton() {
	const bet = useContext(MyBetsBetContext);
	const store = useContext(MyBetsStoreContext);

	if (store == null || !WEBPACK_IS_AUTOCASHOUT_ENABLED) {
		return null;
	}

	const autoCashoutButtonClasses = classNames(
		"bet--actions__btn btn btn--square btn--square--med btn--primary--inverted btn--icon btn--block u-type--sml",
		{
			"bet__btn--autosell--set": bet.isAutoCashoutSet,
		}
	);

	const autoCashoutIconClasses = classNames("u-icon u-icon--sml", {
		"u-icon--settings": !bet.isAutoCashoutSet,
		"u-icon--set-stake": bet.isAutoCashoutSet,
	});

	if (
		WEBPACK_IS_AUTOCASHOUT_ENABLED &&
		bet.displayedAmount !== undefined &&
		bet.displayedAmount !== null &&
		bet.displayedAmount !== "0.00"
	) {
		return (
			<button
				className={autoCashoutButtonClasses}
				type="button"
				onClick={() => store.cashoutStore.openAutosellModal(bet)}
			>
				<i className={autoCashoutIconClasses} />
			</button>
		);
	} else {
		return null;
	}
});
